module.exports = __webpack_public_path__ + "img/bg_people_home_02_1.8847075c.png";